module.exports = __webpack_public_path__ + "static/img/avatar.6f073e6c.png";